// @flow
import { IconType } from 'trustar-2.0/types';
export const SLACK: IconType = { name: 'slack', content: '\ea11'};
export const GRAPH_ICON: IconType = { name: 'graph-icon', content: '\ea09'};
export const CARD_FLIP: IconType = { name: 'card-flip', content: '\ea0a'};
export const FULL_REPORT: IconType = { name: 'full-report', content: '\ea0b'};
export const REPORTS_ICON: IconType = { name: 'reports-icon', content: '\ea0c'};
export const DB: IconType = { name: 'DB', content: '\ea0d'};
export const PHISHING: IconType = { name: 'phishing', content: '\e975'};
export const WORKFLOWS: IconType = { name: 'workflows', content: '\ea02'};
export const EXCLAMATION1: IconType = { name: 'exclamation1', content: '\ea2f'};
export const NAVBAR_TOUR: IconType = { name: 'navbar-tour', content: '\e9ee'};
export const IOC_TAGS: IconType = { name: 'ioc-tags', content: '\e9ef'};
export const NAVBAR_USER: IconType = { name: 'navbar-user', content: '\e9f0'};
export const NAVBAR_CASES: IconType = { name: 'navbar-cases', content: '\e9f1'};
export const IOC_REGISTRY_KEY: IconType = { name: 'ioc-registry-key', content: '\e9f2'};
export const IOC_MALWARE: IconType = { name: 'ioc-malware', content: '\e9f3'};
export const IOC_FILE: IconType = { name: 'ioc-file', content: '\e9f4'};
export const IOC_IP: IconType = { name: 'ioc-ip', content: '\e9f5'};
export const IOC_HASH: IconType = { name: 'ioc-hash', content: '\e9f6'};
export const IOC_GLOBE: IconType = { name: 'ioc-globe', content: '\e9f7'};
export const IOC_AT: IconType = { name: 'ioc-AT', content: '\e9fb'};
export const NAVBAR_IOC: IconType = { name: 'navbar-IOC', content: '\e9fc'};
export const NAVBAR_FUNNEL1: IconType = { name: 'navbar-funnel1', content: '\e9ea'};
export const EXCLAMATION: IconType = { name: 'exclamation', content: '\ea2e'};
export const NAVBAR_MARKETPLACE: IconType = { name: 'navbar-marketplace', content: '\e9ec'};
export const NAVBAR_NOTIFICATIONS: IconType = { name: 'navbar-notifications', content: '\e9ed'};
export const HOME: IconType = { name: 'home', content: '\e600'};
export const HOME2: IconType = { name: 'home2', content: '\e601'};
export const HOME3: IconType = { name: 'home3', content: '\e602'};
export const HOME4: IconType = { name: 'home4', content: '\e603'};
export const HOME5: IconType = { name: 'home5', content: '\e604'};
export const HOME6: IconType = { name: 'home6', content: '\e605'};
export const BATHTUB: IconType = { name: 'bathtub', content: '\e606'};
export const TOOTHBRUSH: IconType = { name: 'toothbrush', content: '\e607'};
export const BED: IconType = { name: 'bed', content: '\e608'};
export const COUCH: IconType = { name: 'couch', content: '\e609'};
export const CHAIR: IconType = { name: 'chair', content: '\e60a'};
export const CITY: IconType = { name: 'city', content: '\e60b'};
export const APARTMENT: IconType = { name: 'apartment', content: '\e60c'};
export const PENCIL: IconType = { name: 'pencil', content: '\e60d'};
export const PENCIL2: IconType = { name: 'pencil2', content: '\e60e'};
export const PEN: IconType = { name: 'pen', content: '\e60f'};
export const PENCIL3: IconType = { name: 'pencil3', content: '\e610'};
export const ERASER: IconType = { name: 'eraser', content: '\e611'};
export const PENCIL4: IconType = { name: 'pencil4', content: '\e612'};
export const PENCIL5: IconType = { name: 'pencil5', content: '\e613'};
export const FEATHER: IconType = { name: 'feather', content: '\e614'};
export const FEATHER2: IconType = { name: 'feather2', content: '\e615'};
export const FEATHER3: IconType = { name: 'feather3', content: '\e616'};
export const PEN2: IconType = { name: 'pen2', content: '\e617'};
export const PEN_ADD: IconType = { name: 'pen-add', content: '\e618'};
export const PEN_REMOVE: IconType = { name: 'pen-remove', content: '\e619'};
export const VECTOR: IconType = { name: 'vector', content: '\e61a'};
export const PEN3: IconType = { name: 'pen3', content: '\e61b'};
export const BLOG: IconType = { name: 'blog', content: '\e61c'};
export const BRUSH: IconType = { name: 'brush', content: '\e61d'};
export const BRUSH2: IconType = { name: 'brush2', content: '\e61e'};
export const SPRAY: IconType = { name: 'spray', content: '\e61f'};
export const PAINT_ROLLER: IconType = { name: 'paint-roller', content: '\e620'};
export const STAMP: IconType = { name: 'stamp', content: '\e621'};
export const TAPE: IconType = { name: 'tape', content: '\e622'};
export const DESK_TAPE: IconType = { name: 'desk-tape', content: '\e623'};
export const TEXTURE: IconType = { name: 'texture', content: '\e624'};
export const EYE_DROPPER: IconType = { name: 'eye-dropper', content: '\e625'};
export const PALETTE: IconType = { name: 'palette', content: '\e626'};
export const COLOR_SAMPLER: IconType = { name: 'color-sampler', content: '\e627'};
export const BUCKET: IconType = { name: 'bucket', content: '\e628'};
export const GRADIENT: IconType = { name: 'gradient', content: '\e629'};
export const GRADIENT2: IconType = { name: 'gradient2', content: '\e62a'};
export const MAGIC_WAND: IconType = { name: 'magic-wand', content: '\e62b'};
export const MAGNET: IconType = { name: 'magnet', content: '\e62c'};
export const PENCIL_RULER: IconType = { name: 'pencil-ruler', content: '\e62d'};
export const PENCIL_RULER2: IconType = { name: 'pencil-ruler2', content: '\e62e'};
export const COMPASS: IconType = { name: 'compass', content: '\e62f'};
export const AIM: IconType = { name: 'aim', content: '\e630'};
export const GUN: IconType = { name: 'gun', content: '\e631'};
export const BOTTLE: IconType = { name: 'bottle', content: '\e632'};
export const DROP: IconType = { name: 'drop', content: '\e633'};
export const DROP_CROSSED: IconType = { name: 'drop-crossed', content: '\e634'};
export const DROP2: IconType = { name: 'drop2', content: '\e635'};
export const SNOW: IconType = { name: 'snow', content: '\e636'};
export const SNOW2: IconType = { name: 'snow2', content: '\e637'};
export const FIRE: IconType = { name: 'fire', content: '\e638'};
export const LIGHTER: IconType = { name: 'lighter', content: '\e639'};
export const KNIFE: IconType = { name: 'knife', content: '\e63a'};
export const DAGGER: IconType = { name: 'dagger', content: '\e63b'};
export const TISSUE: IconType = { name: 'tissue', content: '\e63c'};
export const TOILET_PAPER: IconType = { name: 'toilet-paper', content: '\e63d'};
export const POOP: IconType = { name: 'poop', content: '\e63e'};
export const UMBRELLA: IconType = { name: 'umbrella', content: '\e63f'};
export const UMBRELLA2: IconType = { name: 'umbrella2', content: '\e640'};
export const RAIN: IconType = { name: 'rain', content: '\e641'};
export const TORNADO: IconType = { name: 'tornado', content: '\e642'};
export const WIND: IconType = { name: 'wind', content: '\e643'};
export const FAN: IconType = { name: 'fan', content: '\e644'};
export const CONTRAST: IconType = { name: 'contrast', content: '\e645'};
export const SUN_SMALL: IconType = { name: 'sun-small', content: '\e646'};
export const SUN: IconType = { name: 'sun', content: '\e647'};
export const SUN2: IconType = { name: 'sun2', content: '\e648'};
export const MOON: IconType = { name: 'moon', content: '\e649'};
export const CLOUD: IconType = { name: 'cloud', content: '\e64a'};
export const CLOUD_UPLOAD: IconType = { name: 'cloud-upload', content: '\e64b'};
export const CLOUD_DOWNLOAD: IconType = { name: 'cloud-download', content: '\e64c'};
export const CLOUD_RAIN: IconType = { name: 'cloud-rain', content: '\e64d'};
export const CLOUD_HAILSTONES: IconType = { name: 'cloud-hailstones', content: '\e64e'};
export const CLOUD_SNOW: IconType = { name: 'cloud-snow', content: '\e64f'};
export const CLOUD_WINDY: IconType = { name: 'cloud-windy', content: '\e650'};
export const SUN_WIND: IconType = { name: 'sun-wind', content: '\e651'};
export const CLOUD_FOG: IconType = { name: 'cloud-fog', content: '\e652'};
export const CLOUD_SUN: IconType = { name: 'cloud-sun', content: '\e653'};
export const CLOUD_LIGHTNING: IconType = { name: 'cloud-lightning', content: '\e654'};
export const CLOUD_SYNC: IconType = { name: 'cloud-sync', content: '\e655'};
export const CLOUD_LOCK: IconType = { name: 'cloud-lock', content: '\e656'};
export const CLOUD_GEAR: IconType = { name: 'cloud-gear', content: '\e657'};
export const CLOUD_ALERT: IconType = { name: 'cloud-alert', content: '\e658'};
export const CLOUD_CHECK: IconType = { name: 'cloud-check', content: '\e659'};
export const CLOUD_CROSS: IconType = { name: 'cloud-cross', content: '\e65a'};
export const CLOUD_CROSSED: IconType = { name: 'cloud-crossed', content: '\e65b'};
export const CLOUD_DATABASE: IconType = { name: 'cloud-database', content: '\e65c'};
export const DATABASE: IconType = { name: 'database', content: '\e65d'};
export const DATABASE_ADD: IconType = { name: 'database-add', content: '\e65e'};
export const DATABASE_REMOVE: IconType = { name: 'database-remove', content: '\e65f'};
export const DATABASE_LOCK: IconType = { name: 'database-lock', content: '\e660'};
export const DATABASE_REFRESH: IconType = { name: 'database-refresh', content: '\e661'};
export const DATABASE_CHECK: IconType = { name: 'database-check', content: '\e662'};
export const DATABASE_HISTORY: IconType = { name: 'database-history', content: '\e663'};
export const DATABASE_UPLOAD: IconType = { name: 'database-upload', content: '\e664'};
export const DATABASE_DOWNLOAD: IconType = { name: 'database-download', content: '\e665'};
export const SERVER: IconType = { name: 'server', content: '\e666'};
export const SHIELD1: IconType = { name: 'shield1', content: '\e667'};
export const SHIELD_CHECK: IconType = { name: 'shield-check', content: '\e668'};
export const SHIELD_ALERT: IconType = { name: 'shield-alert', content: '\e669'};
export const SHIELD_CROSS: IconType = { name: 'shield-cross', content: '\e66a'};
export const LOCK: IconType = { name: 'lock', content: '\e66b'};
export const ROTATION_LOCK: IconType = { name: 'rotation-lock', content: '\e66c'};
export const UNLOCK: IconType = { name: 'unlock', content: '\e66d'};
export const KEY: IconType = { name: 'key', content: '\e66e'};
export const KEY_HOLE: IconType = { name: 'key-hole', content: '\e66f'};
export const TOGGLE_OFF: IconType = { name: 'toggle-off', content: '\e670'};
export const TOGGLE_ON: IconType = { name: 'toggle-on', content: '\e671'};
export const COG: IconType = { name: 'cog', content: '\e672'};
export const COG2: IconType = { name: 'cog2', content: '\e673'};
export const WRENCH: IconType = { name: 'wrench', content: '\e674'};
export const SCREWDRIVER: IconType = { name: 'screwdriver', content: '\e675'};
export const HAMMER_WRENCH: IconType = { name: 'hammer-wrench', content: '\e676'};
export const HAMMER: IconType = { name: 'hammer', content: '\e677'};
export const SAW: IconType = { name: 'saw', content: '\e678'};
export const AXE: IconType = { name: 'axe', content: '\e679'};
export const AXE2: IconType = { name: 'axe2', content: '\e67a'};
export const SHOVEL: IconType = { name: 'shovel', content: '\e67b'};
export const PICKAXE: IconType = { name: 'pickaxe', content: '\e67c'};
export const FACTORY: IconType = { name: 'factory', content: '\e67d'};
export const FACTORY2: IconType = { name: 'factory2', content: '\e67e'};
export const RECYCLE: IconType = { name: 'recycle', content: '\e67f'};
export const TRASH: IconType = { name: 'trash', content: '\e680'};
export const TRASH2: IconType = { name: 'trash2', content: '\e681'};
export const TRASH3: IconType = { name: 'trash3', content: '\e682'};
export const BROOM: IconType = { name: 'broom', content: '\e683'};
export const GAME: IconType = { name: 'game', content: '\e684'};
export const GAMEPAD: IconType = { name: 'gamepad', content: '\e685'};
export const JOYSTICK: IconType = { name: 'joystick', content: '\e686'};
export const DICE: IconType = { name: 'dice', content: '\e687'};
export const SPADES: IconType = { name: 'spades', content: '\e688'};
export const DIAMONDS: IconType = { name: 'diamonds', content: '\e689'};
export const CLUBS: IconType = { name: 'clubs', content: '\e68a'};
export const HEARTS: IconType = { name: 'hearts', content: '\e68b'};
export const HEART: IconType = { name: 'heart', content: '\e68c'};
export const STAR: IconType = { name: 'star', content: '\e68d'};
export const STAR_HALF: IconType = { name: 'star-half', content: '\e68e'};
export const STAR_EMPTY: IconType = { name: 'star-empty', content: '\e68f'};
export const FLAG: IconType = { name: 'flag', content: '\e690'};
export const FLAG2: IconType = { name: 'flag2', content: '\e691'};
export const FLAG3: IconType = { name: 'flag3', content: '\e692'};
export const MAILBOX_FULL: IconType = { name: 'mailbox-full', content: '\e693'};
export const MAILBOX_EMPTY: IconType = { name: 'mailbox-empty', content: '\e694'};
export const AT_SIGN: IconType = { name: 'at-sign', content: '\e695'};
export const ENVELOPE: IconType = { name: 'envelope', content: '\e696'};
export const ENVELOPE_OPEN: IconType = { name: 'envelope-open', content: '\e697'};
export const PAPERCLIP: IconType = { name: 'paperclip', content: '\e698'};
export const PAPER_PLANE: IconType = { name: 'paper-plane', content: '\e699'};
export const REPLY: IconType = { name: 'reply', content: '\e69a'};
export const REPLY_ALL: IconType = { name: 'reply-all', content: '\e69b'};
export const INBOX: IconType = { name: 'inbox', content: '\e69c'};
export const INBOX2: IconType = { name: 'inbox2', content: '\e69d'};
export const OUTBOX: IconType = { name: 'outbox', content: '\e69e'};
export const BOX: IconType = { name: 'box', content: '\e69f'};
export const ARCHIVE: IconType = { name: 'archive', content: '\e6a0'};
export const ARCHIVE2: IconType = { name: 'archive2', content: '\e6a1'};
export const DRAWERS: IconType = { name: 'drawers', content: '\e6a2'};
export const DRAWERS2: IconType = { name: 'drawers2', content: '\e6a3'};
export const DRAWERS3: IconType = { name: 'drawers3', content: '\e6a4'};
export const EYE: IconType = { name: 'eye', content: '\e6a5'};
export const EYE_CROSSED: IconType = { name: 'eye-crossed', content: '\e6a6'};
export const EYE_PLUS: IconType = { name: 'eye-plus', content: '\e6a7'};
export const EYE_MINUS: IconType = { name: 'eye-minus', content: '\e6a8'};
export const BINOCULARS: IconType = { name: 'binoculars', content: '\e6a9'};
export const BINOCULARS2: IconType = { name: 'binoculars2', content: '\e6aa'};
export const HDD: IconType = { name: 'hdd', content: '\e6ab'};
export const HDD_DOWN: IconType = { name: 'hdd-down', content: '\e6ac'};
export const HDD_UP: IconType = { name: 'hdd-up', content: '\e6ad'};
export const FLOPPY_DISK: IconType = { name: 'floppy-disk', content: '\e6ae'};
export const DISC: IconType = { name: 'disc', content: '\e6af'};
export const TAPE2: IconType = { name: 'tape2', content: '\e6b0'};
export const PRINTER: IconType = { name: 'printer', content: '\e6b1'};
export const SHREDDER: IconType = { name: 'shredder', content: '\e6b2'};
export const FILE_EMPTY: IconType = { name: 'file-empty', content: '\e6b3'};
export const FILE_ADD: IconType = { name: 'file-add', content: '\e6b4'};
export const FILE_CHECK: IconType = { name: 'file-check', content: '\e6b5'};
export const FILE_LOCK: IconType = { name: 'file-lock', content: '\e6b6'};
export const FILES: IconType = { name: 'files', content: '\e6b7'};
export const COPY: IconType = { name: 'copy', content: '\e6b8'};
export const COMPARE: IconType = { name: 'compare', content: '\e6b9'};
export const FOLDER: IconType = { name: 'folder', content: '\e6ba'};
export const FOLDER_SEARCH: IconType = { name: 'folder-search', content: '\e6bb'};
export const FOLDER_PLUS: IconType = { name: 'folder-plus', content: '\e6bc'};
export const FOLDER_MINUS: IconType = { name: 'folder-minus', content: '\e6bd'};
export const FOLDER_DOWNLOAD: IconType = { name: 'folder-download', content: '\e6be'};
export const FOLDER_UPLOAD: IconType = { name: 'folder-upload', content: '\e6bf'};
export const FOLDER_STAR: IconType = { name: 'folder-star', content: '\e6c0'};
export const FOLDER_HEART: IconType = { name: 'folder-heart', content: '\e6c1'};
export const FOLDER_USER: IconType = { name: 'folder-user', content: '\e6c2'};
export const FOLDER_SHARED: IconType = { name: 'folder-shared', content: '\e6c3'};
export const FOLDER_MUSIC: IconType = { name: 'folder-music', content: '\e6c4'};
export const FOLDER_PICTURE: IconType = { name: 'folder-picture', content: '\e6c5'};
export const FOLDER_FILM: IconType = { name: 'folder-film', content: '\e6c6'};
export const SCISSORS: IconType = { name: 'scissors', content: '\e6c7'};
export const PASTE: IconType = { name: 'paste', content: '\e6c8'};
export const CLIPBOARD_EMPTY: IconType = { name: 'clipboard-empty', content: '\e6c9'};
export const CLIPBOARD_PENCIL: IconType = { name: 'clipboard-pencil', content: '\e6ca'};
export const CLIPBOARD_TEXT: IconType = { name: 'clipboard-text', content: '\e6cb'};
export const CLIPBOARD_CHECK: IconType = { name: 'clipboard-check', content: '\e6cc'};
export const CLIPBOARD_DOWN: IconType = { name: 'clipboard-down', content: '\e6cd'};
export const CLIPBOARD_LEFT: IconType = { name: 'clipboard-left', content: '\e6ce'};
export const CLIPBOARD_ALERT: IconType = { name: 'clipboard-alert', content: '\e6cf'};
export const CLIPBOARD_USER: IconType = { name: 'clipboard-user', content: '\e6d0'};
export const REGISTER: IconType = { name: 'register', content: '\e6d1'};
export const ENTER: IconType = { name: 'enter', content: '\e6d2'};
export const EXIT: IconType = { name: 'exit', content: '\e6d3'};
export const PAPERS: IconType = { name: 'papers', content: '\e6d4'};
export const NEWS: IconType = { name: 'news', content: '\e6d5'};
export const READING: IconType = { name: 'reading', content: '\e6d6'};
export const TYPEWRITER: IconType = { name: 'typewriter', content: '\e6d7'};
export const DOCUMENT: IconType = { name: 'document', content: '\e6d8'};
export const DOCUMENT2: IconType = { name: 'document2', content: '\e6d9'};
export const GRADUATION_HAT: IconType = { name: 'graduation-hat', content: '\e6da'};
export const LICENSE: IconType = { name: 'license', content: '\e6db'};
export const LICENSE2: IconType = { name: 'license2', content: '\e6dc'};
export const MEDAL_EMPTY: IconType = { name: 'medal-empty', content: '\e6dd'};
export const MEDAL_FIRST: IconType = { name: 'medal-first', content: '\e6de'};
export const MEDAL_SECOND: IconType = { name: 'medal-second', content: '\e6df'};
export const MEDAL_THIRD: IconType = { name: 'medal-third', content: '\e6e0'};
export const PODIUM: IconType = { name: 'podium', content: '\e6e1'};
export const TROPHY: IconType = { name: 'trophy', content: '\e6e2'};
export const TROPHY2: IconType = { name: 'trophy2', content: '\e6e3'};
export const MUSIC_NOTE: IconType = { name: 'music-note', content: '\e6e4'};
export const MUSIC_NOTE2: IconType = { name: 'music-note2', content: '\e6e5'};
export const MUSIC_NOTE3: IconType = { name: 'music-note3', content: '\e6e6'};
export const PLAYLIST: IconType = { name: 'playlist', content: '\e6e7'};
export const PLAYLIST_ADD: IconType = { name: 'playlist-add', content: '\e6e8'};
export const GUITAR: IconType = { name: 'guitar', content: '\e6e9'};
export const TRUMPET: IconType = { name: 'trumpet', content: '\e6ea'};
export const ALBUM: IconType = { name: 'album', content: '\e6eb'};
export const SHUFFLE: IconType = { name: 'shuffle', content: '\e6ec'};
export const REPEAT_ONE: IconType = { name: 'repeat-one', content: '\e6ed'};
export const REPEAT: IconType = { name: 'repeat', content: '\e6ee'};
export const HEADPHONES: IconType = { name: 'headphones', content: '\e6ef'};
export const HEADSET: IconType = { name: 'headset', content: '\e6f0'};
export const LOUDSPEAKER: IconType = { name: 'loudspeaker', content: '\e6f1'};
export const EQUALIZER: IconType = { name: 'equalizer', content: '\e6f2'};
export const THEATER: IconType = { name: 'theater', content: '\e6f3'};
export const X_3D_GLASSES: IconType = { name: '3d-glasses', content: '\e6f4'};
export const TICKET: IconType = { name: 'ticket', content: '\e6f5'};
export const PRESENTATION: IconType = { name: 'presentation', content: '\e6f6'};
export const PLAY: IconType = { name: 'play', content: '\e6f7'};
export const FILM_PLAY: IconType = { name: 'film-play', content: '\e6f8'};
export const CLAPBOARD_PLAY: IconType = { name: 'clapboard-play', content: '\e6f9'};
export const MEDIA: IconType = { name: 'media', content: '\e6fa'};
export const FILM: IconType = { name: 'film', content: '\e6fb'};
export const FILM2: IconType = { name: 'film2', content: '\e6fc'};
export const SURVEILLANCE: IconType = { name: 'surveillance', content: '\e6fd'};
export const SURVEILLANCE2: IconType = { name: 'surveillance2', content: '\e6fe'};
export const CAMERA: IconType = { name: 'camera', content: '\e6ff'};
export const CAMERA_CROSSED: IconType = { name: 'camera-crossed', content: '\e700'};
export const CAMERA_PLAY: IconType = { name: 'camera-play', content: '\e701'};
export const TIME_LAPSE: IconType = { name: 'time-lapse', content: '\e702'};
export const RECORD: IconType = { name: 'record', content: '\e703'};
export const CAMERA2: IconType = { name: 'camera2', content: '\e704'};
export const CAMERA_FLIP: IconType = { name: 'camera-flip', content: '\e705'};
export const PANORAMA: IconType = { name: 'panorama', content: '\e706'};
export const TIME_LAPSE2: IconType = { name: 'time-lapse2', content: '\e707'};
export const SHUTTER: IconType = { name: 'shutter', content: '\e708'};
export const SHUTTER2: IconType = { name: 'shutter2', content: '\e709'};
export const FACE_DETECTION: IconType = { name: 'face-detection', content: '\e70a'};
export const FLARE: IconType = { name: 'flare', content: '\e70b'};
export const CONVEX: IconType = { name: 'convex', content: '\e70c'};
export const CONCAVE: IconType = { name: 'concave', content: '\e70d'};
export const PICTURE: IconType = { name: 'picture', content: '\e70e'};
export const PICTURE2: IconType = { name: 'picture2', content: '\e70f'};
export const PICTURE3: IconType = { name: 'picture3', content: '\e710'};
export const PICTURES: IconType = { name: 'pictures', content: '\e711'};
export const BOOK: IconType = { name: 'book', content: '\e712'};
export const AUDIO_BOOK: IconType = { name: 'audio-book', content: '\e713'};
export const BOOK2: IconType = { name: 'book2', content: '\e714'};
export const BOOKMARK: IconType = { name: 'bookmark', content: '\e715'};
export const BOOKMARK2: IconType = { name: 'bookmark2', content: '\e716'};
export const LABEL: IconType = { name: 'label', content: '\e717'};
export const LIBRARY: IconType = { name: 'library', content: '\e718'};
export const LIBRARY2: IconType = { name: 'library2', content: '\e719'};
export const CONTACTS: IconType = { name: 'contacts', content: '\e71a'};
export const PROFILE: IconType = { name: 'profile', content: '\e71b'};
export const PORTRAIT: IconType = { name: 'portrait', content: '\e71c'};
export const PORTRAIT2: IconType = { name: 'portrait2', content: '\e71d'};
export const USER1: IconType = { name: 'user1', content: '\e71e'};
export const USER_PLUS: IconType = { name: 'user-plus', content: '\e71f'};
export const USER_MINUS: IconType = { name: 'user-minus', content: '\e720'};
export const USER_LOCK: IconType = { name: 'user-lock', content: '\e721'};
export const USERS: IconType = { name: 'users', content: '\e722'};
export const USERS2: IconType = { name: 'users2', content: '\e723'};
export const USERS_PLUS: IconType = { name: 'users-plus', content: '\e724'};
export const USERS_MINUS: IconType = { name: 'users-minus', content: '\e725'};
export const GROUP_WORK: IconType = { name: 'group-work', content: '\e726'};
export const WOMAN: IconType = { name: 'woman', content: '\e727'};
export const MAN: IconType = { name: 'man', content: '\e728'};
export const BABY: IconType = { name: 'baby', content: '\e729'};
export const BABY2: IconType = { name: 'baby2', content: '\e72a'};
export const BABY3: IconType = { name: 'baby3', content: '\e72b'};
export const BABY_BOTTLE: IconType = { name: 'baby-bottle', content: '\e72c'};
export const WALK: IconType = { name: 'walk', content: '\e72d'};
export const HAND_WAVING: IconType = { name: 'hand-waving', content: '\e72e'};
export const JUMP: IconType = { name: 'jump', content: '\e72f'};
export const RUN: IconType = { name: 'run', content: '\e730'};
export const WOMAN2: IconType = { name: 'woman2', content: '\e731'};
export const MAN2: IconType = { name: 'man2', content: '\e732'};
export const MAN_WOMAN: IconType = { name: 'man-woman', content: '\e733'};
export const HEIGHT: IconType = { name: 'height', content: '\e734'};
export const WEIGHT: IconType = { name: 'weight', content: '\e735'};
export const SCALE: IconType = { name: 'scale', content: '\e736'};
export const BUTTON: IconType = { name: 'button', content: '\e737'};
export const BOW_TIE: IconType = { name: 'bow-tie', content: '\e738'};
export const TIE: IconType = { name: 'tie', content: '\e739'};
export const SOCKS: IconType = { name: 'socks', content: '\e73a'};
export const SHOE: IconType = { name: 'shoe', content: '\e73b'};
export const SHOES: IconType = { name: 'shoes', content: '\e73c'};
export const HAT: IconType = { name: 'hat', content: '\e73d'};
export const PANTS: IconType = { name: 'pants', content: '\e73e'};
export const SHORTS: IconType = { name: 'shorts', content: '\e73f'};
export const FLIP_FLOPS: IconType = { name: 'flip-flops', content: '\e740'};
export const SHIRT: IconType = { name: 'shirt', content: '\e741'};
export const HANGER: IconType = { name: 'hanger', content: '\e742'};
export const LAUNDRY: IconType = { name: 'laundry', content: '\e743'};
export const STORE: IconType = { name: 'store', content: '\e744'};
export const HAIRCUT: IconType = { name: 'haircut', content: '\e745'};
export const STORE_24: IconType = { name: 'store-24', content: '\e746'};
export const BARCODE: IconType = { name: 'barcode', content: '\e747'};
export const BARCODE2: IconType = { name: 'barcode2', content: '\e748'};
export const BARCODE3: IconType = { name: 'barcode3', content: '\e749'};
export const CASHIER: IconType = { name: 'cashier', content: '\e74a'};
export const BAG: IconType = { name: 'bag', content: '\e74b'};
export const BAG2: IconType = { name: 'bag2', content: '\e74c'};
export const CART: IconType = { name: 'cart', content: '\e74d'};
export const CART_EMPTY: IconType = { name: 'cart-empty', content: '\e74e'};
export const CART_FULL: IconType = { name: 'cart-full', content: '\e74f'};
export const CART_PLUS: IconType = { name: 'cart-plus', content: '\e750'};
export const CART_PLUS2: IconType = { name: 'cart-plus2', content: '\e751'};
export const CART_ADD: IconType = { name: 'cart-add', content: '\e752'};
export const CART_REMOVE: IconType = { name: 'cart-remove', content: '\e753'};
export const CART_EXCHANGE: IconType = { name: 'cart-exchange', content: '\e754'};
export const TAG: IconType = { name: 'tag', content: '\e755'};
export const TAGS1: IconType = { name: 'tags1', content: '\e756'};
export const RECEIPT: IconType = { name: 'receipt', content: '\e757'};
export const WALLET: IconType = { name: 'wallet', content: '\e758'};
export const CREDIT_CARD: IconType = { name: 'credit-card', content: '\e759'};
export const CASH_DOLLAR: IconType = { name: 'cash-dollar', content: '\e75a'};
export const CASH_EURO: IconType = { name: 'cash-euro', content: '\e75b'};
export const CASH_POUND: IconType = { name: 'cash-pound', content: '\e75c'};
export const CASH_YEN: IconType = { name: 'cash-yen', content: '\e75d'};
export const BAG_DOLLAR: IconType = { name: 'bag-dollar', content: '\e75e'};
export const BAG_EURO: IconType = { name: 'bag-euro', content: '\e75f'};
export const BAG_POUND: IconType = { name: 'bag-pound', content: '\e760'};
export const BAG_YEN: IconType = { name: 'bag-yen', content: '\e761'};
export const COIN_DOLLAR: IconType = { name: 'coin-dollar', content: '\e762'};
export const COIN_EURO: IconType = { name: 'coin-euro', content: '\e763'};
export const COIN_POUND: IconType = { name: 'coin-pound', content: '\e764'};
export const COIN_YEN: IconType = { name: 'coin-yen', content: '\e765'};
export const CALCULATOR: IconType = { name: 'calculator', content: '\e766'};
export const CALCULATOR2: IconType = { name: 'calculator2', content: '\e767'};
export const ABACUS: IconType = { name: 'abacus', content: '\e768'};
export const VAULT: IconType = { name: 'vault', content: '\e769'};
export const TELEPHONE: IconType = { name: 'telephone', content: '\e76a'};
export const PHONE_LOCK: IconType = { name: 'phone-lock', content: '\e76b'};
export const PHONE_WAVE: IconType = { name: 'phone-wave', content: '\e76c'};
export const PHONE_PAUSE: IconType = { name: 'phone-pause', content: '\e76d'};
export const PHONE_OUTGOING: IconType = { name: 'phone-outgoing', content: '\e76e'};
export const PHONE_INCOMING: IconType = { name: 'phone-incoming', content: '\e76f'};
export const PHONE_IN_OUT: IconType = { name: 'phone-in-out', content: '\e770'};
export const PHONE_ERROR: IconType = { name: 'phone-error', content: '\e771'};
export const PHONE_SIP: IconType = { name: 'phone-sip', content: '\e772'};
export const PHONE_PLUS: IconType = { name: 'phone-plus', content: '\e773'};
export const PHONE_MINUS: IconType = { name: 'phone-minus', content: '\e774'};
export const VOICEMAIL: IconType = { name: 'voicemail', content: '\e775'};
export const DIAL: IconType = { name: 'dial', content: '\e776'};
export const TELEPHONE2: IconType = { name: 'telephone2', content: '\e777'};
export const PUSHPIN: IconType = { name: 'pushpin', content: '\e778'};
export const PUSHPIN2: IconType = { name: 'pushpin2', content: '\e779'};
export const MAP_MARKER: IconType = { name: 'map-marker', content: '\e77a'};
export const MAP_MARKER_USER: IconType = { name: 'map-marker-user', content: '\e77b'};
export const MAP_MARKER_DOWN: IconType = { name: 'map-marker-down', content: '\e77c'};
export const MAP_MARKER_CHECK: IconType = { name: 'map-marker-check', content: '\e77d'};
export const MAP_MARKER_CROSSED: IconType = { name: 'map-marker-crossed', content: '\e77e'};
export const RADAR: IconType = { name: 'radar', content: '\e77f'};
export const COMPASS2: IconType = { name: 'compass2', content: '\e780'};
export const MAP: IconType = { name: 'map', content: '\e781'};
export const MAP2: IconType = { name: 'map2', content: '\e782'};
export const LOCATION: IconType = { name: 'location', content: '\e783'};
export const ROAD_SIGN: IconType = { name: 'road-sign', content: '\e784'};
export const CALENDAR_EMPTY: IconType = { name: 'calendar-empty', content: '\e785'};
export const CALENDAR_CHECK: IconType = { name: 'calendar-check', content: '\e786'};
export const CALENDAR_CROSS: IconType = { name: 'calendar-cross', content: '\e787'};
export const CALENDAR_31: IconType = { name: 'calendar-31', content: '\e788'};
export const CALENDAR_FULL: IconType = { name: 'calendar-full', content: '\e789'};
export const CALENDAR_INSERT: IconType = { name: 'calendar-insert', content: '\e78a'};
export const CALENDAR_TEXT: IconType = { name: 'calendar-text', content: '\e78b'};
export const CALENDAR_USER: IconType = { name: 'calendar-user', content: '\e78c'};
export const MOUSE: IconType = { name: 'mouse', content: '\e78d'};
export const MOUSE_LEFT: IconType = { name: 'mouse-left', content: '\e78e'};
export const MOUSE_RIGHT: IconType = { name: 'mouse-right', content: '\e78f'};
export const MOUSE_BOTH: IconType = { name: 'mouse-both', content: '\e790'};
export const KEYBOARD: IconType = { name: 'keyboard', content: '\e791'};
export const KEYBOARD_UP: IconType = { name: 'keyboard-up', content: '\e792'};
export const KEYBOARD_DOWN: IconType = { name: 'keyboard-down', content: '\e793'};
export const DELETE: IconType = { name: 'delete', content: '\e794'};
export const SPELL_CHECK: IconType = { name: 'spell-check', content: '\e795'};
export const ESCAPE: IconType = { name: 'escape', content: '\e796'};
export const ENTER2: IconType = { name: 'enter2', content: '\e797'};
export const SCREEN: IconType = { name: 'screen', content: '\e798'};
export const ASPECT_RATIO: IconType = { name: 'aspect-ratio', content: '\e799'};
export const SIGNAL: IconType = { name: 'signal', content: '\e79a'};
export const SIGNAL_LOCK: IconType = { name: 'signal-lock', content: '\e79b'};
export const SIGNAL_80: IconType = { name: 'signal-80', content: '\e79c'};
export const SIGNAL_60: IconType = { name: 'signal-60', content: '\e79d'};
export const SIGNAL_40: IconType = { name: 'signal-40', content: '\e79e'};
export const SIGNAL_20: IconType = { name: 'signal-20', content: '\e79f'};
export const SIGNAL_0: IconType = { name: 'signal-0', content: '\e7a0'};
export const SIGNAL_BLOCKED: IconType = { name: 'signal-blocked', content: '\e7a1'};
export const SIM: IconType = { name: 'sim', content: '\e7a2'};
export const FLASH_MEMORY: IconType = { name: 'flash-memory', content: '\e7a3'};
export const USB_DRIVE: IconType = { name: 'usb-drive', content: '\e7a4'};
export const PHONE: IconType = { name: 'phone', content: '\e7a5'};
export const SMARTPHONE: IconType = { name: 'smartphone', content: '\e7a6'};
export const SMARTPHONE_NOTIFICATION: IconType = { name: 'smartphone-notification', content: '\e7a7'};
export const SMARTPHONE_VIBRATION: IconType = { name: 'smartphone-vibration', content: '\e7a8'};
export const SMARTPHONE_EMBED: IconType = { name: 'smartphone-embed', content: '\e7a9'};
export const SMARTPHONE_WAVES: IconType = { name: 'smartphone-waves', content: '\e7aa'};
export const TABLET: IconType = { name: 'tablet', content: '\e7ab'};
export const TABLET2: IconType = { name: 'tablet2', content: '\e7ac'};
export const LAPTOP: IconType = { name: 'laptop', content: '\e7ad'};
export const LAPTOP_PHONE: IconType = { name: 'laptop-phone', content: '\e7ae'};
export const DESKTOP: IconType = { name: 'desktop', content: '\e7af'};
export const LAUNCH: IconType = { name: 'launch', content: '\e7b0'};
export const NEW_TAB: IconType = { name: 'new-tab', content: '\e7b1'};
export const WINDOW: IconType = { name: 'window', content: '\e7b2'};
export const CABLE: IconType = { name: 'cable', content: '\e7b3'};
export const CABLE2: IconType = { name: 'cable2', content: '\e7b4'};
export const TV: IconType = { name: 'tv', content: '\e7b5'};
export const RADIO: IconType = { name: 'radio', content: '\e7b6'};
export const REMOTE_CONTROL: IconType = { name: 'remote-control', content: '\e7b7'};
export const POWER_SWITCH: IconType = { name: 'power-switch', content: '\e7b8'};
export const POWER: IconType = { name: 'power', content: '\e7b9'};
export const POWER_CROSSED: IconType = { name: 'power-crossed', content: '\e7ba'};
export const FLASH_AUTO: IconType = { name: 'flash-auto', content: '\e7bb'};
export const LAMP: IconType = { name: 'lamp', content: '\e7bc'};
export const FLASHLIGHT: IconType = { name: 'flashlight', content: '\e7bd'};
export const LAMPSHADE: IconType = { name: 'lampshade', content: '\e7be'};
export const CORD: IconType = { name: 'cord', content: '\e7bf'};
export const OUTLET: IconType = { name: 'outlet', content: '\e7c0'};
export const BATTERY_POWER: IconType = { name: 'battery-power', content: '\e7c1'};
export const BATTERY_EMPTY: IconType = { name: 'battery-empty', content: '\e7c2'};
export const BATTERY_ALERT: IconType = { name: 'battery-alert', content: '\e7c3'};
export const BATTERY_ERROR: IconType = { name: 'battery-error', content: '\e7c4'};
export const BATTERY_LOW1: IconType = { name: 'battery-low1', content: '\e7c5'};
export const BATTERY_LOW2: IconType = { name: 'battery-low2', content: '\e7c6'};
export const BATTERY_LOW3: IconType = { name: 'battery-low3', content: '\e7c7'};
export const BATTERY_MID1: IconType = { name: 'battery-mid1', content: '\e7c8'};
export const BATTERY_MID2: IconType = { name: 'battery-mid2', content: '\e7c9'};
export const BATTERY_MID3: IconType = { name: 'battery-mid3', content: '\e7ca'};
export const BATTERY_FULL: IconType = { name: 'battery-full', content: '\e7cb'};
export const BATTERY_CHARGING: IconType = { name: 'battery-charging', content: '\e7cc'};
export const BATTERY_CHARGING2: IconType = { name: 'battery-charging2', content: '\e7cd'};
export const BATTERY_CHARGING3: IconType = { name: 'battery-charging3', content: '\e7ce'};
export const BATTERY_CHARGING4: IconType = { name: 'battery-charging4', content: '\e7cf'};
export const BATTERY_CHARGING5: IconType = { name: 'battery-charging5', content: '\e7d0'};
export const BATTERY_CHARGING6: IconType = { name: 'battery-charging6', content: '\e7d1'};
export const BATTERY_CHARGING7: IconType = { name: 'battery-charging7', content: '\e7d2'};
export const CHIP: IconType = { name: 'chip', content: '\e7d3'};
export const CHIP_X64: IconType = { name: 'chip-x64', content: '\e7d4'};
export const CHIP_X86: IconType = { name: 'chip-x86', content: '\e7d5'};
export const BUBBLE: IconType = { name: 'bubble', content: '\e7d6'};
export const BUBBLES: IconType = { name: 'bubbles', content: '\e7d7'};
export const BUBBLE_DOTS: IconType = { name: 'bubble-dots', content: '\e7d8'};
export const BUBBLE_ALERT: IconType = { name: 'bubble-alert', content: '\e7d9'};
export const BUBBLE_QUESTION: IconType = { name: 'bubble-question', content: '\e7da'};
export const BUBBLE_TEXT: IconType = { name: 'bubble-text', content: '\e7db'};
export const BUBBLE_PENCIL: IconType = { name: 'bubble-pencil', content: '\e7dc'};
export const BUBBLE_PICTURE: IconType = { name: 'bubble-picture', content: '\e7dd'};
export const BUBBLE_VIDEO: IconType = { name: 'bubble-video', content: '\e7de'};
export const BUBBLE_USER: IconType = { name: 'bubble-user', content: '\e7df'};
export const BUBBLE_QUOTE: IconType = { name: 'bubble-quote', content: '\e7e0'};
export const BUBBLE_HEART: IconType = { name: 'bubble-heart', content: '\e7e1'};
export const BUBBLE_EMOTICON: IconType = { name: 'bubble-emoticon', content: '\e7e2'};
export const BUBBLE_ATTACHMENT: IconType = { name: 'bubble-attachment', content: '\e7e3'};
export const PHONE_BUBBLE: IconType = { name: 'phone-bubble', content: '\e7e4'};
export const QUOTE_OPEN: IconType = { name: 'quote-open', content: '\e7e5'};
export const QUOTE_CLOSE: IconType = { name: 'quote-close', content: '\e7e6'};
export const DNA: IconType = { name: 'dna', content: '\e7e7'};
export const HEART_PULSE: IconType = { name: 'heart-pulse', content: '\e7e8'};
export const PULSE: IconType = { name: 'pulse', content: '\e7e9'};
export const SYRINGE: IconType = { name: 'syringe', content: '\e7ea'};
export const PILLS: IconType = { name: 'pills', content: '\e7eb'};
export const FIRST_AID: IconType = { name: 'first-aid', content: '\e7ec'};
export const LIFEBUOY: IconType = { name: 'lifebuoy', content: '\e7ed'};
export const BANDAGE: IconType = { name: 'bandage', content: '\e7ee'};
export const BANDAGES: IconType = { name: 'bandages', content: '\e7ef'};
export const THERMOMETER: IconType = { name: 'thermometer', content: '\e7f0'};
export const MICROSCOPE: IconType = { name: 'microscope', content: '\e7f1'};
export const BRAIN: IconType = { name: 'brain', content: '\e7f2'};
export const BEAKER: IconType = { name: 'beaker', content: '\e7f3'};
export const SKULL: IconType = { name: 'skull', content: '\e7f4'};
export const BONE: IconType = { name: 'bone', content: '\e7f5'};
export const CONSTRUCTION: IconType = { name: 'construction', content: '\e7f6'};
export const CONSTRUCTION_CONE: IconType = { name: 'construction-cone', content: '\e7f7'};
export const PIE_CHART: IconType = { name: 'pie-chart', content: '\e7f8'};
export const PIE_CHART2: IconType = { name: 'pie-chart2', content: '\e7f9'};
export const GRAPH: IconType = { name: 'graph', content: '\e7fa'};
export const CHART_GROWTH: IconType = { name: 'chart-growth', content: '\e7fb'};
export const CHART_BARS: IconType = { name: 'chart-bars', content: '\e7fc'};
export const CHART_SETTINGS: IconType = { name: 'chart-settings', content: '\e7fd'};
export const CAKE: IconType = { name: 'cake', content: '\e7fe'};
export const GIFT: IconType = { name: 'gift', content: '\e7ff'};
export const BALLOON: IconType = { name: 'balloon', content: '\e800'};
export const RANK: IconType = { name: 'rank', content: '\e801'};
export const RANK2: IconType = { name: 'rank2', content: '\e802'};
export const RANK3: IconType = { name: 'rank3', content: '\e803'};
export const CROWN: IconType = { name: 'crown', content: '\e804'};
export const LOTUS: IconType = { name: 'lotus', content: '\e805'};
export const DIAMOND: IconType = { name: 'diamond', content: '\e806'};
export const DIAMOND2: IconType = { name: 'diamond2', content: '\e807'};
export const DIAMOND3: IconType = { name: 'diamond3', content: '\e808'};
export const DIAMOND4: IconType = { name: 'diamond4', content: '\e809'};
export const LINEARICONS: IconType = { name: 'linearicons', content: '\e80a'};
export const TEACUP: IconType = { name: 'teacup', content: '\e80b'};
export const TEAPOT: IconType = { name: 'teapot', content: '\e80c'};
export const GLASS: IconType = { name: 'glass', content: '\e80d'};
export const BOTTLE2: IconType = { name: 'bottle2', content: '\e80e'};
export const GLASS_COCKTAIL: IconType = { name: 'glass-cocktail', content: '\e80f'};
export const GLASS2: IconType = { name: 'glass2', content: '\e810'};
export const DINNER: IconType = { name: 'dinner', content: '\e811'};
export const DINNER2: IconType = { name: 'dinner2', content: '\e812'};
export const CHEF: IconType = { name: 'chef', content: '\e813'};
export const SCALE2: IconType = { name: 'scale2', content: '\e814'};
export const EGG: IconType = { name: 'egg', content: '\e815'};
export const EGG2: IconType = { name: 'egg2', content: '\e816'};
export const EGGS: IconType = { name: 'eggs', content: '\e817'};
export const PLATTER: IconType = { name: 'platter', content: '\e818'};
export const STEAK: IconType = { name: 'steak', content: '\e819'};
export const HAMBURGER: IconType = { name: 'hamburger', content: '\e81a'};
export const HOTDOG: IconType = { name: 'hotdog', content: '\e81b'};
export const PIZZA: IconType = { name: 'pizza', content: '\e81c'};
export const SAUSAGE: IconType = { name: 'sausage', content: '\e81d'};
export const CHICKEN: IconType = { name: 'chicken', content: '\e81e'};
export const FISH: IconType = { name: 'fish', content: '\e81f'};
export const CARROT: IconType = { name: 'carrot', content: '\e820'};
export const CHEESE: IconType = { name: 'cheese', content: '\e821'};
export const BREAD: IconType = { name: 'bread', content: '\e822'};
export const ICE_CREAM: IconType = { name: 'ice-cream', content: '\e823'};
export const ICE_CREAM2: IconType = { name: 'ice-cream2', content: '\e824'};
export const CANDY: IconType = { name: 'candy', content: '\e825'};
export const LOLLIPOP: IconType = { name: 'lollipop', content: '\e826'};
export const COFFEE_BEAN: IconType = { name: 'coffee-bean', content: '\e827'};
export const COFFEE_CUP: IconType = { name: 'coffee-cup', content: '\e828'};
export const CHERRY: IconType = { name: 'cherry', content: '\e829'};
export const GRAPES: IconType = { name: 'grapes', content: '\e82a'};
export const CITRUS: IconType = { name: 'citrus', content: '\e82b'};
export const APPLE: IconType = { name: 'apple', content: '\e82c'};
export const LEAF: IconType = { name: 'leaf', content: '\e82d'};
export const LANDSCAPE: IconType = { name: 'landscape', content: '\e82e'};
export const PINE_TREE: IconType = { name: 'pine-tree', content: '\e82f'};
export const TREE: IconType = { name: 'tree', content: '\e830'};
export const CACTUS: IconType = { name: 'cactus', content: '\e831'};
export const PAW: IconType = { name: 'paw', content: '\e832'};
export const FOOTPRINT: IconType = { name: 'footprint', content: '\e833'};
export const SPEED_SLOW: IconType = { name: 'speed-slow', content: '\e834'};
export const SPEED_MEDIUM: IconType = { name: 'speed-medium', content: '\e835'};
export const SPEED_FAST: IconType = { name: 'speed-fast', content: '\e836'};
export const ROCKET: IconType = { name: 'rocket', content: '\e837'};
export const HAMMER2: IconType = { name: 'hammer2', content: '\e838'};
export const BALANCE: IconType = { name: 'balance', content: '\e839'};
export const BRIEFCASE: IconType = { name: 'briefcase', content: '\e83a'};
export const LUGGAGE_WEIGHT: IconType = { name: 'luggage-weight', content: '\e83b'};
export const DOLLY: IconType = { name: 'dolly', content: '\e83c'};
export const PLANE: IconType = { name: 'plane', content: '\e83d'};
export const PLANE_CROSSED: IconType = { name: 'plane-crossed', content: '\e83e'};
export const HELICOPTER: IconType = { name: 'helicopter', content: '\e83f'};
export const TRAFFIC_LIGHTS: IconType = { name: 'traffic-lights', content: '\e840'};
export const SIREN: IconType = { name: 'siren', content: '\e841'};
export const ROAD: IconType = { name: 'road', content: '\e842'};
export const ENGINE: IconType = { name: 'engine', content: '\e843'};
export const OIL_PRESSURE: IconType = { name: 'oil-pressure', content: '\e844'};
export const COOLANT_TEMPERATURE: IconType = { name: 'coolant-temperature', content: '\e845'};
export const CAR_BATTERY: IconType = { name: 'car-battery', content: '\e846'};
export const GAS: IconType = { name: 'gas', content: '\e847'};
export const GALLON: IconType = { name: 'gallon', content: '\e848'};
export const TRANSMISSION: IconType = { name: 'transmission', content: '\e849'};
export const CAR: IconType = { name: 'car', content: '\e84a'};
export const CAR_WASH: IconType = { name: 'car-wash', content: '\e84b'};
export const CAR_WASH2: IconType = { name: 'car-wash2', content: '\e84c'};
export const BUS: IconType = { name: 'bus', content: '\e84d'};
export const BUS2: IconType = { name: 'bus2', content: '\e84e'};
export const CAR2: IconType = { name: 'car2', content: '\e84f'};
export const PARKING: IconType = { name: 'parking', content: '\e850'};
export const CAR_LOCK: IconType = { name: 'car-lock', content: '\e851'};
export const TAXI: IconType = { name: 'taxi', content: '\e852'};
export const CAR_SIREN: IconType = { name: 'car-siren', content: '\e853'};
export const CAR_WASH3: IconType = { name: 'car-wash3', content: '\e854'};
export const CAR_WASH4: IconType = { name: 'car-wash4', content: '\e855'};
export const AMBULANCE: IconType = { name: 'ambulance', content: '\e856'};
export const TRUCK: IconType = { name: 'truck', content: '\e857'};
export const TRAILER: IconType = { name: 'trailer', content: '\e858'};
export const SCALE_TRUCK: IconType = { name: 'scale-truck', content: '\e859'};
export const TRAIN: IconType = { name: 'train', content: '\e85a'};
export const SHIP: IconType = { name: 'ship', content: '\e85b'};
export const SHIP2: IconType = { name: 'ship2', content: '\e85c'};
export const ANCHOR: IconType = { name: 'anchor', content: '\e85d'};
export const BOAT: IconType = { name: 'boat', content: '\e85e'};
export const BICYCLE: IconType = { name: 'bicycle', content: '\e85f'};
export const BICYCLE2: IconType = { name: 'bicycle2', content: '\e860'};
export const DUMBBELL: IconType = { name: 'dumbbell', content: '\e861'};
export const BENCH_PRESS: IconType = { name: 'bench-press', content: '\e862'};
export const SWIM: IconType = { name: 'swim', content: '\e863'};
export const FOOTBALL: IconType = { name: 'football', content: '\e864'};
export const BASEBALL_BAT: IconType = { name: 'baseball-bat', content: '\e865'};
export const BASEBALL: IconType = { name: 'baseball', content: '\e866'};
export const TENNIS: IconType = { name: 'tennis', content: '\e867'};
export const TENNIS2: IconType = { name: 'tennis2', content: '\e868'};
export const PING_PONG: IconType = { name: 'ping-pong', content: '\e869'};
export const HOCKEY: IconType = { name: 'hockey', content: '\e86a'};
export const X_8BALL: IconType = { name: '8ball', content: '\e86b'};
export const BOWLING: IconType = { name: 'bowling', content: '\e86c'};
export const BOWLING_PINS: IconType = { name: 'bowling-pins', content: '\e86d'};
export const GOLF: IconType = { name: 'golf', content: '\e86e'};
export const GOLF2: IconType = { name: 'golf2', content: '\e86f'};
export const ARCHERY: IconType = { name: 'archery', content: '\e870'};
export const SLINGSHOT: IconType = { name: 'slingshot', content: '\e871'};
export const SOCCER: IconType = { name: 'soccer', content: '\e872'};
export const BASKETBALL: IconType = { name: 'basketball', content: '\e873'};
export const CUBE: IconType = { name: 'cube', content: '\e874'};
export const X_3D_ROTATE: IconType = { name: '3d-rotate', content: '\e875'};
export const PUZZLE: IconType = { name: 'puzzle', content: '\e876'};
export const GLASSES: IconType = { name: 'glasses', content: '\e877'};
export const GLASSES2: IconType = { name: 'glasses2', content: '\e878'};
export const ACCESSIBILITY: IconType = { name: 'accessibility', content: '\e879'};
export const WHEELCHAIR: IconType = { name: 'wheelchair', content: '\e87a'};
export const WALL: IconType = { name: 'wall', content: '\e87b'};
export const FENCE: IconType = { name: 'fence', content: '\e87c'};
export const WALL2: IconType = { name: 'wall2', content: '\e87d'};
export const ICONS: IconType = { name: 'icons', content: '\e87e'};
export const RESIZE_HANDLE: IconType = { name: 'resize-handle', content: '\e87f'};
export const ICONS2: IconType = { name: 'icons2', content: '\e880'};
export const SELECT: IconType = { name: 'select', content: '\e881'};
export const SELECT2: IconType = { name: 'select2', content: '\e882'};
export const SITE_MAP: IconType = { name: 'site-map', content: '\e883'};
export const EARTH: IconType = { name: 'earth', content: '\e884'};
export const EARTH_LOCK: IconType = { name: 'earth-lock', content: '\e885'};
export const NETWORK: IconType = { name: 'network', content: '\e886'};
export const NETWORK_LOCK: IconType = { name: 'network-lock', content: '\e887'};
export const PLANET: IconType = { name: 'planet', content: '\e888'};
export const HAPPY: IconType = { name: 'happy', content: '\e889'};
export const SMILE: IconType = { name: 'smile', content: '\e88a'};
export const GRIN: IconType = { name: 'grin', content: '\e88b'};
export const TONGUE: IconType = { name: 'tongue', content: '\e88c'};
export const SAD: IconType = { name: 'sad', content: '\e88d'};
export const WINK: IconType = { name: 'wink', content: '\e88e'};
export const DREAM: IconType = { name: 'dream', content: '\e88f'};
export const SHOCKED: IconType = { name: 'shocked', content: '\e890'};
export const SHOCKED2: IconType = { name: 'shocked2', content: '\e891'};
export const TONGUE2: IconType = { name: 'tongue2', content: '\e892'};
export const NEUTRAL: IconType = { name: 'neutral', content: '\e893'};
export const HAPPY_GRIN: IconType = { name: 'happy-grin', content: '\e894'};
export const COOL: IconType = { name: 'cool', content: '\e895'};
export const MAD: IconType = { name: 'mad', content: '\e896'};
export const GRIN_EVIL: IconType = { name: 'grin-evil', content: '\e897'};
export const EVIL: IconType = { name: 'evil', content: '\e898'};
export const WOW: IconType = { name: 'wow', content: '\e899'};
export const ANNOYED: IconType = { name: 'annoyed', content: '\e89a'};
export const WONDERING: IconType = { name: 'wondering', content: '\e89b'};
export const CONFUSED: IconType = { name: 'confused', content: '\e89c'};
export const ZIPPED: IconType = { name: 'zipped', content: '\e89d'};
export const GRUMPY: IconType = { name: 'grumpy', content: '\e89e'};
export const MUSTACHE: IconType = { name: 'mustache', content: '\e89f'};
export const TOMBSTONE_HIPSTER: IconType = { name: 'tombstone-hipster', content: '\e8a0'};
export const TOMBSTONE: IconType = { name: 'tombstone', content: '\e8a1'};
export const GHOST: IconType = { name: 'ghost', content: '\e8a2'};
export const GHOST_HIPSTER: IconType = { name: 'ghost-hipster', content: '\e8a3'};
export const HALLOWEEN: IconType = { name: 'halloween', content: '\e8a4'};
export const CHRISTMAS: IconType = { name: 'christmas', content: '\e8a5'};
export const EASTER_EGG: IconType = { name: 'easter-egg', content: '\e8a6'};
export const MUSTACHE2: IconType = { name: 'mustache2', content: '\e8a7'};
export const MUSTACHE_GLASSES: IconType = { name: 'mustache-glasses', content: '\e8a8'};
export const PIPE: IconType = { name: 'pipe', content: '\e8a9'};
export const ALARM: IconType = { name: 'alarm', content: '\e8aa'};
export const ALARM_ADD: IconType = { name: 'alarm-add', content: '\e8ab'};
export const ALARM_SNOOZE: IconType = { name: 'alarm-snooze', content: '\e8ac'};
export const ALARM_RINGING: IconType = { name: 'alarm-ringing', content: '\e8ad'};
export const BULLHORN: IconType = { name: 'bullhorn', content: '\e8ae'};
export const HEARING: IconType = { name: 'hearing', content: '\e8af'};
export const VOLUME_HIGH: IconType = { name: 'volume-high', content: '\e8b0'};
export const VOLUME_MEDIUM: IconType = { name: 'volume-medium', content: '\e8b1'};
export const VOLUME_LOW: IconType = { name: 'volume-low', content: '\e8b2'};
export const VOLUME: IconType = { name: 'volume', content: '\e8b3'};
export const MUTE: IconType = { name: 'mute', content: '\e8b4'};
export const LAN: IconType = { name: 'lan', content: '\e8b5'};
export const LAN2: IconType = { name: 'lan2', content: '\e8b6'};
export const WIFI: IconType = { name: 'wifi', content: '\e8b7'};
export const WIFI_LOCK: IconType = { name: 'wifi-lock', content: '\e8b8'};
export const WIFI_BLOCKED: IconType = { name: 'wifi-blocked', content: '\e8b9'};
export const WIFI_MID: IconType = { name: 'wifi-mid', content: '\e8ba'};
export const WIFI_LOW: IconType = { name: 'wifi-low', content: '\e8bb'};
export const WIFI_LOW2: IconType = { name: 'wifi-low2', content: '\e8bc'};
export const WIFI_ALERT: IconType = { name: 'wifi-alert', content: '\e8bd'};
export const WIFI_ALERT_MID: IconType = { name: 'wifi-alert-mid', content: '\e8be'};
export const WIFI_ALERT_LOW: IconType = { name: 'wifi-alert-low', content: '\e8bf'};
export const WIFI_ALERT_LOW2: IconType = { name: 'wifi-alert-low2', content: '\e8c0'};
export const STREAM: IconType = { name: 'stream', content: '\e8c1'};
export const STREAM_CHECK: IconType = { name: 'stream-check', content: '\e8c2'};
export const STREAM_ERROR: IconType = { name: 'stream-error', content: '\e8c3'};
export const STREAM_ALERT: IconType = { name: 'stream-alert', content: '\e8c4'};
export const COMMUNICATION: IconType = { name: 'communication', content: '\e8c5'};
export const COMMUNICATION_CROSSED: IconType = { name: 'communication-crossed', content: '\e8c6'};
export const BROADCAST: IconType = { name: 'broadcast', content: '\e8c7'};
export const ANTENNA: IconType = { name: 'antenna', content: '\e8c8'};
export const SATELLITE: IconType = { name: 'satellite', content: '\e8c9'};
export const SATELLITE2: IconType = { name: 'satellite2', content: '\e8ca'};
export const MIC: IconType = { name: 'mic', content: '\e8cb'};
export const MIC_MUTE: IconType = { name: 'mic-mute', content: '\e8cc'};
export const MIC2: IconType = { name: 'mic2', content: '\e8cd'};
export const SPOTLIGHTS: IconType = { name: 'spotlights', content: '\e8ce'};
export const HOURGLASS: IconType = { name: 'hourglass', content: '\e8cf'};
export const LOADING: IconType = { name: 'loading', content: '\e8d0'};
export const LOADING2: IconType = { name: 'loading2', content: '\e8d1'};
export const LOADING3: IconType = { name: 'loading3', content: '\e8d2'};
export const REFRESH: IconType = { name: 'refresh', content: '\e8d3'};
export const REFRESH2: IconType = { name: 'refresh2', content: '\e8d4'};
export const UNDO: IconType = { name: 'undo', content: '\e8d5'};
export const REDO: IconType = { name: 'redo', content: '\e8d6'};
export const JUMP2: IconType = { name: 'jump2', content: '\e8d7'};
export const UNDO2: IconType = { name: 'undo2', content: '\e8d8'};
export const REDO2: IconType = { name: 'redo2', content: '\e8d9'};
export const SYNC: IconType = { name: 'sync', content: '\e8da'};
export const REPEAT_ONE2: IconType = { name: 'repeat-one2', content: '\e8db'};
export const SYNC_CROSSED: IconType = { name: 'sync-crossed', content: '\e8dc'};
export const SYNC2: IconType = { name: 'sync2', content: '\e8dd'};
export const REPEAT_ONE3: IconType = { name: 'repeat-one3', content: '\e8de'};
export const SYNC_CROSSED2: IconType = { name: 'sync-crossed2', content: '\e8df'};
export const RETURN: IconType = { name: 'return', content: '\e8e0'};
export const RETURN2: IconType = { name: 'return2', content: '\e8e1'};
export const REFUND: IconType = { name: 'refund', content: '\e8e2'};
export const HISTORY: IconType = { name: 'history', content: '\e8e3'};
export const HISTORY2: IconType = { name: 'history2', content: '\e8e4'};
export const SELF_TIMER: IconType = { name: 'self-timer', content: '\e8e5'};
export const CLOCK: IconType = { name: 'clock', content: '\e8e6'};
export const CLOCK2: IconType = { name: 'clock2', content: '\e8e7'};
export const CLOCK3: IconType = { name: 'clock3', content: '\e8e8'};
export const WATCH: IconType = { name: 'watch', content: '\e8e9'};
export const ALARM2: IconType = { name: 'alarm2', content: '\e8ea'};
export const ALARM_ADD2: IconType = { name: 'alarm-add2', content: '\e8eb'};
export const ALARM_REMOVE: IconType = { name: 'alarm-remove', content: '\e8ec'};
export const ALARM_CHECK: IconType = { name: 'alarm-check', content: '\e8ed'};
export const ALARM_ERROR: IconType = { name: 'alarm-error', content: '\e8ee'};
export const TIMER: IconType = { name: 'timer', content: '\e8ef'};
export const TIMER_CROSSED: IconType = { name: 'timer-crossed', content: '\e8f0'};
export const TIMER2: IconType = { name: 'timer2', content: '\e8f1'};
export const TIMER_CROSSED2: IconType = { name: 'timer-crossed2', content: '\e8f2'};
export const DOWNLOAD: IconType = { name: 'download', content: '\e8f3'};
export const UPLOAD: IconType = { name: 'upload', content: '\e8f4'};
export const DOWNLOAD2: IconType = { name: 'download2', content: '\e8f5'};
export const UPLOAD2: IconType = { name: 'upload2', content: '\e8f6'};
export const ENTER_UP: IconType = { name: 'enter-up', content: '\e8f7'};
export const ENTER_DOWN: IconType = { name: 'enter-down', content: '\e8f8'};
export const ENTER_LEFT: IconType = { name: 'enter-left', content: '\e8f9'};
export const ENTER_RIGHT: IconType = { name: 'enter-right', content: '\e8fa'};
export const EXIT_UP: IconType = { name: 'exit-up', content: '\e8fb'};
export const EXIT_DOWN: IconType = { name: 'exit-down', content: '\e8fc'};
export const EXIT_LEFT: IconType = { name: 'exit-left', content: '\e8fd'};
export const EXIT_RIGHT: IconType = { name: 'exit-right', content: '\e8fe'};
export const ENTER_UP2: IconType = { name: 'enter-up2', content: '\e8ff'};
export const ENTER_DOWN2: IconType = { name: 'enter-down2', content: '\e901'};
export const ENTER_VERTICAL: IconType = { name: 'enter-vertical', content: '\e902'};
export const ENTER_LEFT2: IconType = { name: 'enter-left2', content: '\e903'};
export const ENTER_RIGHT2: IconType = { name: 'enter-right2', content: '\e904'};
export const ENTER_HORIZONTAL: IconType = { name: 'enter-horizontal', content: '\e905'};
export const EXIT_UP2: IconType = { name: 'exit-up2', content: '\e906'};
export const EXIT_DOWN2: IconType = { name: 'exit-down2', content: '\e907'};
export const EXIT_LEFT2: IconType = { name: 'exit-left2', content: '\e908'};
export const EXIT_RIGHT2: IconType = { name: 'exit-right2', content: '\e909'};
export const CLI: IconType = { name: 'cli', content: '\e90a'};
export const BUG: IconType = { name: 'bug', content: '\e90b'};
export const CODE: IconType = { name: 'code', content: '\e90c'};
export const FILE_CODE: IconType = { name: 'file-code', content: '\e90d'};
export const FILE_IMAGE: IconType = { name: 'file-image', content: '\e90e'};
export const FILE_ZIP: IconType = { name: 'file-zip', content: '\e90f'};
export const FILE_AUDIO: IconType = { name: 'file-audio', content: '\e910'};
export const FILE_VIDEO: IconType = { name: 'file-video', content: '\e911'};
export const FILE_PREVIEW: IconType = { name: 'file-preview', content: '\e912'};
export const FILE_CHARTS: IconType = { name: 'file-charts', content: '\e913'};
export const FILE_STATS: IconType = { name: 'file-stats', content: '\e914'};
export const FILE_SPREADSHEET: IconType = { name: 'file-spreadsheet', content: '\e915'};
export const LINK: IconType = { name: 'link', content: '\e916'};
export const UNLINK: IconType = { name: 'unlink', content: '\e917'};
export const LINK2: IconType = { name: 'link2', content: '\e918'};
export const UNLINK2: IconType = { name: 'unlink2', content: '\e919'};
export const THUMBS_UP: IconType = { name: 'thumbs-up', content: '\e91a'};
export const THUMBS_DOWN: IconType = { name: 'thumbs-down', content: '\e91b'};
export const THUMBS_UP2: IconType = { name: 'thumbs-up2', content: '\e91c'};
export const THUMBS_DOWN2: IconType = { name: 'thumbs-down2', content: '\e91d'};
export const THUMBS_UP3: IconType = { name: 'thumbs-up3', content: '\e91e'};
export const THUMBS_DOWN3: IconType = { name: 'thumbs-down3', content: '\e91f'};
export const SHARE: IconType = { name: 'share', content: '\e920'};
export const SHARE2: IconType = { name: 'share2', content: '\e921'};
export const SHARE3: IconType = { name: 'share3', content: '\e922'};
export const MAGNIFIER: IconType = { name: 'magnifier', content: '\e923'};
export const FILE_SEARCH: IconType = { name: 'file-search', content: '\e924'};
export const FIND_REPLACE: IconType = { name: 'find-replace', content: '\e925'};
export const ZOOM_IN: IconType = { name: 'zoom-in', content: '\e926'};
export const ZOOM_OUT: IconType = { name: 'zoom-out', content: '\e927'};
export const LOUPE: IconType = { name: 'loupe', content: '\e928'};
export const LOUPE_ZOOM_IN: IconType = { name: 'loupe-zoom-in', content: '\e929'};
export const LOUPE_ZOOM_OUT: IconType = { name: 'loupe-zoom-out', content: '\e92a'};
export const CROSS: IconType = { name: 'cross', content: '\e92b'};
export const MENU: IconType = { name: 'menu', content: '\e92c'};
export const LIST: IconType = { name: 'list', content: '\e92d'};
export const LIST2: IconType = { name: 'list2', content: '\e92e'};
export const LIST3: IconType = { name: 'list3', content: '\e92f'};
export const MENU2: IconType = { name: 'menu2', content: '\e930'};
export const LIST4: IconType = { name: 'list4', content: '\e931'};
export const MENU3: IconType = { name: 'menu3', content: '\e932'};
export const EXCLAMATION2: IconType = { name: 'exclamation2', content: '\e933'};
export const QUESTION: IconType = { name: 'question', content: '\e934'};
export const CHECK: IconType = { name: 'check', content: '\e935'};
export const CROSS2: IconType = { name: 'cross2', content: '\e936'};
export const PLUS: IconType = { name: 'plus', content: '\e937'};
export const MINUS: IconType = { name: 'minus', content: '\e938'};
export const PERCENT: IconType = { name: 'percent', content: '\e939'};
export const CHEVRON_UP: IconType = { name: 'chevron-up', content: '\e93a'};
export const CHEVRON_DOWN: IconType = { name: 'chevron-down', content: '\e93b'};
export const CHEVRON_LEFT: IconType = { name: 'chevron-left', content: '\e93c'};
export const CHEVRON_RIGHT: IconType = { name: 'chevron-right', content: '\e93d'};
export const CHEVRONS_EXPAND_VERTICAL: IconType = { name: 'chevrons-expand-vertical', content: '\e93e'};
export const CHEVRONS_EXPAND_HORIZONTAL: IconType = { name: 'chevrons-expand-horizontal', content: '\e93f'};
export const CHEVRONS_CONTRACT_VERTICAL: IconType = { name: 'chevrons-contract-vertical', content: '\e940'};
export const CHEVRONS_CONTRACT_HORIZONTAL: IconType = { name: 'chevrons-contract-horizontal', content: '\e941'};
export const ARROW_UP: IconType = { name: 'arrow-up', content: '\e942'};
export const ARROW_DOWN: IconType = { name: 'arrow-down', content: '\e943'};
export const ARROW_LEFT: IconType = { name: 'arrow-left', content: '\e944'};
export const ARROW_RIGHT: IconType = { name: 'arrow-right', content: '\e945'};
export const ARROW_UP_RIGHT: IconType = { name: 'arrow-up-right', content: '\e946'};
export const ARROWS_MERGE: IconType = { name: 'arrows-merge', content: '\e947'};
export const ARROWS_SPLIT: IconType = { name: 'arrows-split', content: '\e948'};
export const ARROW_DIVERT: IconType = { name: 'arrow-divert', content: '\e949'};
export const ARROW_RETURN: IconType = { name: 'arrow-return', content: '\e94a'};
export const EXPAND: IconType = { name: 'expand', content: '\e94b'};
export const CONTRACT: IconType = { name: 'contract', content: '\e94c'};
export const EXPAND2: IconType = { name: 'expand2', content: '\e94d'};
export const CONTRACT2: IconType = { name: 'contract2', content: '\e94e'};
export const MOVE: IconType = { name: 'move', content: '\e94f'};
export const TAB: IconType = { name: 'tab', content: '\e950'};
export const ARROW_WAVE: IconType = { name: 'arrow-wave', content: '\e951'};
export const EXPAND3: IconType = { name: 'expand3', content: '\e952'};
export const EXPAND4: IconType = { name: 'expand4', content: '\e953'};
export const CONTRACT3: IconType = { name: 'contract3', content: '\e954'};
export const NOTIFICATION: IconType = { name: 'notification', content: '\e955'};
export const WARNING: IconType = { name: 'warning', content: '\e956'};
export const NOTIFICATION_CIRCLE: IconType = { name: 'notification-circle', content: '\e957'};
export const QUESTION_CIRCLE: IconType = { name: 'question-circle', content: '\e958'};
export const MENU_CIRCLE: IconType = { name: 'menu-circle', content: '\e959'};
export const CHECKMARK_CIRCLE: IconType = { name: 'checkmark-circle', content: '\e95a'};
export const CROSS_CIRCLE: IconType = { name: 'cross-circle', content: '\e95b'};
export const PLUS_CIRCLE: IconType = { name: 'plus-circle', content: '\e95c'};
export const CIRCLE_MINUS: IconType = { name: 'circle-minus', content: '\e95d'};
export const PERCENT_CIRCLE: IconType = { name: 'percent-circle', content: '\e95e'};
export const ARROW_UP_CIRCLE: IconType = { name: 'arrow-up-circle', content: '\e95f'};
export const ARROW_DOWN_CIRCLE: IconType = { name: 'arrow-down-circle', content: '\e960'};
export const ARROW_LEFT_CIRCLE: IconType = { name: 'arrow-left-circle', content: '\e961'};
export const ARROW_RIGHT_CIRCLE: IconType = { name: 'arrow-right-circle', content: '\e962'};
export const CHEVRON_UP_CIRCLE: IconType = { name: 'chevron-up-circle', content: '\e963'};
export const CHEVRON_DOWN_CIRCLE: IconType = { name: 'chevron-down-circle', content: '\e964'};
export const CHEVRON_LEFT_CIRCLE: IconType = { name: 'chevron-left-circle', content: '\e965'};
export const CHEVRON_RIGHT_CIRCLE: IconType = { name: 'chevron-right-circle', content: '\e966'};
export const BACKWARD_CIRCLE: IconType = { name: 'backward-circle', content: '\e967'};
export const FIRST_CIRCLE: IconType = { name: 'first-circle', content: '\e968'};
export const PREVIOUS_CIRCLE: IconType = { name: 'previous-circle', content: '\e969'};
export const STOP_CIRCLE: IconType = { name: 'stop-circle', content: '\e96a'};
export const PLAY_CIRCLE: IconType = { name: 'play-circle', content: '\e96b'};
export const PAUSE_CIRCLE: IconType = { name: 'pause-circle', content: '\e96c'};
export const NEXT_CIRCLE: IconType = { name: 'next-circle', content: '\e96d'};
export const LAST_CIRCLE: IconType = { name: 'last-circle', content: '\e96e'};
export const FORWARD_CIRCLE: IconType = { name: 'forward-circle', content: '\e96f'};
export const EJECT_CIRCLE: IconType = { name: 'eject-circle', content: '\e970'};
export const CROP: IconType = { name: 'crop', content: '\e971'};
export const FRAME_EXPAND: IconType = { name: 'frame-expand', content: '\e972'};
export const FRAME_CONTRACT: IconType = { name: 'frame-contract', content: '\e973'};
export const FOCUS: IconType = { name: 'focus', content: '\e974'};
export const GRID: IconType = { name: 'grid', content: '\e976'};
export const GRID_CROSSED: IconType = { name: 'grid-crossed', content: '\e977'};
export const LAYERS: IconType = { name: 'layers', content: '\e978'};
export const LAYERS_CROSSED: IconType = { name: 'layers-crossed', content: '\e979'};
export const TOGGLE: IconType = { name: 'toggle', content: '\e97a'};
export const RULERS: IconType = { name: 'rulers', content: '\e97b'};
export const RULER: IconType = { name: 'ruler', content: '\e97c'};
export const FUNNEL1: IconType = { name: 'funnel1', content: '\e97d'};
export const FLIP_HORIZONTAL: IconType = { name: 'flip-horizontal', content: '\e97e'};
export const FLIP_VERTICAL: IconType = { name: 'flip-vertical', content: '\e97f'};
export const FLIP_HORIZONTAL2: IconType = { name: 'flip-horizontal2', content: '\e980'};
export const FLIP_VERTICAL2: IconType = { name: 'flip-vertical2', content: '\e981'};
export const ANGLE: IconType = { name: 'angle', content: '\e982'};
export const ANGLE2: IconType = { name: 'angle2', content: '\e983'};
export const SUBTRACT: IconType = { name: 'subtract', content: '\e984'};
export const COMBINE: IconType = { name: 'combine', content: '\e985'};
export const INTERSECT: IconType = { name: 'intersect', content: '\e986'};
export const EXCLUDE: IconType = { name: 'exclude', content: '\e987'};
export const ALIGN_CENTER_VERTICAL: IconType = { name: 'align-center-vertical', content: '\e988'};
export const ALIGN_RIGHT: IconType = { name: 'align-right', content: '\e989'};
export const ALIGN_BOTTOM: IconType = { name: 'align-bottom', content: '\e98a'};
export const ALIGN_LEFT: IconType = { name: 'align-left', content: '\e98b'};
export const ALIGN_CENTER_HORIZONTAL: IconType = { name: 'align-center-horizontal', content: '\e98c'};
export const ALIGN_TOP: IconType = { name: 'align-top', content: '\e98d'};
export const SQUARE: IconType = { name: 'square', content: '\e98e'};
export const PLUS_SQUARE: IconType = { name: 'plus-square', content: '\e98f'};
export const MINUS_SQUARE: IconType = { name: 'minus-square', content: '\e990'};
export const PERCENT_SQUARE: IconType = { name: 'percent-square', content: '\e991'};
export const ARROW_UP_SQUARE: IconType = { name: 'arrow-up-square', content: '\e992'};
export const ARROW_DOWN_SQUARE: IconType = { name: 'arrow-down-square', content: '\e993'};
export const ARROW_LEFT_SQUARE: IconType = { name: 'arrow-left-square', content: '\e994'};
export const ARROW_RIGHT_SQUARE: IconType = { name: 'arrow-right-square', content: '\e995'};
export const CHEVRON_UP_SQUARE: IconType = { name: 'chevron-up-square', content: '\e996'};
export const CHEVRON_DOWN_SQUARE: IconType = { name: 'chevron-down-square', content: '\e997'};
export const CHEVRON_LEFT_SQUARE: IconType = { name: 'chevron-left-square', content: '\e998'};
export const CHEVRON_RIGHT_SQUARE: IconType = { name: 'chevron-right-square', content: '\e999'};
export const CHECK_SQUARE: IconType = { name: 'check-square', content: '\e99a'};
export const CROSS_SQUARE: IconType = { name: 'cross-square', content: '\e99b'};
export const MENU_SQUARE: IconType = { name: 'menu-square', content: '\e99c'};
export const PROHIBITED: IconType = { name: 'prohibited', content: '\e99d'};
export const CIRCLE: IconType = { name: 'circle', content: '\e99e'};
export const RADIO_BUTTON: IconType = { name: 'radio-button', content: '\e99f'};
export const LIGATURE: IconType = { name: 'ligature', content: '\e9a0'};
export const TEXT_FORMAT: IconType = { name: 'text-format', content: '\e9a1'};
export const TEXT_FORMAT_REMOVE: IconType = { name: 'text-format-remove', content: '\e9a2'};
export const TEXT_SIZE: IconType = { name: 'text-size', content: '\e9a3'};
export const BOLD: IconType = { name: 'bold', content: '\e9a4'};
export const ITALIC: IconType = { name: 'italic', content: '\e9a5'};
export const UNDERLINE: IconType = { name: 'underline', content: '\e9a6'};
export const STRIKETHROUGH: IconType = { name: 'strikethrough', content: '\e9a7'};
export const HIGHLIGHT: IconType = { name: 'highlight', content: '\e9a8'};
export const TEXT_ALIGN_LEFT: IconType = { name: 'text-align-left', content: '\e9a9'};
export const TEXT_ALIGN_CENTER: IconType = { name: 'text-align-center', content: '\e9aa'};
export const TEXT_ALIGN_RIGHT: IconType = { name: 'text-align-right', content: '\e9ab'};
export const TEXT_ALIGN_JUSTIFY: IconType = { name: 'text-align-justify', content: '\e9ac'};
export const LINE_SPACING: IconType = { name: 'line-spacing', content: '\e9ad'};
export const INDENT_INCREASE: IconType = { name: 'indent-increase', content: '\e9ae'};
export const INDENT_DECREASE: IconType = { name: 'indent-decrease', content: '\e9af'};
export const TEXT_WRAP: IconType = { name: 'text-wrap', content: '\e9b0'};
export const PILCROW: IconType = { name: 'pilcrow', content: '\e9b1'};
export const DIRECTION_LTR: IconType = { name: 'direction-ltr', content: '\e9b2'};
export const DIRECTION_RTL: IconType = { name: 'direction-rtl', content: '\e9b3'};
export const PAGE_BREAK: IconType = { name: 'page-break', content: '\e9b4'};
export const PAGE_BREAK2: IconType = { name: 'page-break2', content: '\e9b5'};
export const SORT_ALPHA_ASC: IconType = { name: 'sort-alpha-asc', content: '\e9b6'};
export const SORT_ALPHA_DESC: IconType = { name: 'sort-alpha-desc', content: '\e9b7'};
export const SORT_NUMERIC_ASC: IconType = { name: 'sort-numeric-asc', content: '\e9b8'};
export const SORT_NUMERIC_DESC: IconType = { name: 'sort-numeric-desc', content: '\e9b9'};
export const SORT_AMOUNT_ASC: IconType = { name: 'sort-amount-asc', content: '\e9ba'};
export const SORT_AMOUNT_DESC: IconType = { name: 'sort-amount-desc', content: '\e9bb'};
export const SORT_TIME_ASC: IconType = { name: 'sort-time-asc', content: '\e9bc'};
export const SORT_TIME_DESC: IconType = { name: 'sort-time-desc', content: '\e9bd'};
export const SIGMA: IconType = { name: 'sigma', content: '\e9be'};
export const PENCIL_LINE: IconType = { name: 'pencil-line', content: '\e9bf'};
export const HAND: IconType = { name: 'hand', content: '\e9c0'};
export const POINTER_UP: IconType = { name: 'pointer-up', content: '\e9c1'};
export const POINTER_RIGHT: IconType = { name: 'pointer-right', content: '\e9c2'};
export const POINTER_DOWN: IconType = { name: 'pointer-down', content: '\e9c3'};
export const POINTER_LEFT: IconType = { name: 'pointer-left', content: '\e9c4'};
export const FINGER_TAP: IconType = { name: 'finger-tap', content: '\e9c5'};
export const FINGERS_TAP: IconType = { name: 'fingers-tap', content: '\e9c6'};
export const REMINDER: IconType = { name: 'reminder', content: '\e9c7'};
export const FINGERS_CROSSED: IconType = { name: 'fingers-crossed', content: '\e9c8'};
export const FINGERS_VICTORY: IconType = { name: 'fingers-victory', content: '\e9c9'};
export const GESTURE_ZOOM: IconType = { name: 'gesture-zoom', content: '\e9ca'};
export const GESTURE_PINCH: IconType = { name: 'gesture-pinch', content: '\e9cb'};
export const FINGERS_SCROLL_HORIZONTAL: IconType = { name: 'fingers-scroll-horizontal', content: '\e9cc'};
export const FINGERS_SCROLL_VERTICAL: IconType = { name: 'fingers-scroll-vertical', content: '\e9cd'};
export const FINGERS_SCROLL_LEFT: IconType = { name: 'fingers-scroll-left', content: '\e9ce'};
export const FINGERS_SCROLL_RIGHT: IconType = { name: 'fingers-scroll-right', content: '\e9cf'};
export const HAND2: IconType = { name: 'hand2', content: '\e9d0'};
export const POINTER_UP2: IconType = { name: 'pointer-up2', content: '\e9d1'};
export const POINTER_RIGHT2: IconType = { name: 'pointer-right2', content: '\e9d2'};
export const POINTER_DOWN2: IconType = { name: 'pointer-down2', content: '\e9d3'};
export const POINTER_LEFT2: IconType = { name: 'pointer-left2', content: '\e9d4'};
export const FINGER_TAP2: IconType = { name: 'finger-tap2', content: '\e9d5'};
export const FINGERS_TAP2: IconType = { name: 'fingers-tap2', content: '\e9d6'};
export const REMINDER2: IconType = { name: 'reminder2', content: '\e9d7'};
export const GESTURE_ZOOM2: IconType = { name: 'gesture-zoom2', content: '\e9d8'};
export const GESTURE_PINCH2: IconType = { name: 'gesture-pinch2', content: '\e9d9'};
export const FINGERS_SCROLL_HORIZONTAL2: IconType = { name: 'fingers-scroll-horizontal2', content: '\e9da'};
export const FINGERS_SCROLL_VERTICAL2: IconType = { name: 'fingers-scroll-vertical2', content: '\e9db'};
export const FINGERS_SCROLL_LEFT2: IconType = { name: 'fingers-scroll-left2', content: '\e9dc'};
export const FINGERS_SCROLL_RIGHT2: IconType = { name: 'fingers-scroll-right2', content: '\e9dd'};
export const FINGERS_SCROLL_VERTICAL3: IconType = { name: 'fingers-scroll-vertical3', content: '\e9de'};
export const BORDER_STYLE: IconType = { name: 'border-style', content: '\e9df'};
export const BORDER_ALL: IconType = { name: 'border-all', content: '\e9e0'};
export const BORDER_OUTER: IconType = { name: 'border-outer', content: '\e9e1'};
export const BORDER_INNER: IconType = { name: 'border-inner', content: '\e9e2'};
export const BORDER_TOP: IconType = { name: 'border-top', content: '\e9e3'};
export const BORDER_HORIZONTAL: IconType = { name: 'border-horizontal', content: '\e9e4'};
export const BORDER_BOTTOM: IconType = { name: 'border-bottom', content: '\e9e5'};
export const BORDER_LEFT: IconType = { name: 'border-left', content: '\e9e6'};
export const BORDER_VERTICAL: IconType = { name: 'border-vertical', content: '\e9e7'};
export const BORDER_RIGHT: IconType = { name: 'border-right', content: '\e9e8'};
export const BORDER_NONE: IconType = { name: 'border-none', content: '\e9e9'};
export const ELLIPSIS: IconType = { name: 'ellipsis', content: '\ea10'};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Icon/constants.js